import { useContext } from 'react';
import { Box, Text } from '@rsos/base-components';
import { FlagContext } from '@rsos/flags/src/FlagProvider';
import { DebugPanel } from '../DebugPanel';
import FlagOverrideItem from './FlagOverrideItem';

const FlagDebugPanel = ({ onClose }: { onClose?: () => void }) => {
  const { flags: allFlags, updateFlag } = useContext(FlagContext);

  const sortedFlags = Object.entries(allFlags).sort(([keyA], [keyB]) =>
    keyA.localeCompare(keyB),
  );

  return (
    <DebugPanel title="Feature Flag Override" onClose={onClose}>
      <Text color="secondaryText" size="small">
        These values are local only and overrides will not be persisted. Not all
        flags will take effect if changed after the page loads.
      </Text>
      <Box
        height="400px"
        overflow="auto"
        border="1px solid"
        borderColor="heavyLineOutline"
      >
        {sortedFlags.map(([flagKey, flagValue]) => (
          <FlagOverrideItem
            flagKey={flagKey}
            flagValue={Boolean(flagValue)}
            onClick={updateFlag}
            key={flagKey}
          />
        ))}
      </Box>
    </DebugPanel>
  );
};

export default FlagDebugPanel;
